import { createExternalStore } from './createExternalStore';

/**
 * Inbox search/list client-only state, migrated off Apollo `makeVar` reactive vars.
 * Read reactively via `useValue()`; written imperatively via `set()`.
 */

/** Whether ConversationList is fetching data; drives the loading skeletons across the inbox. */
export const inboxPageIsLoadingStore = createExternalStore(false);

/** Conversation id ConversationList should filter to, set from the search bar. */
export const inboxPageConversationIdToFilterByStore = createExternalStore('');

/** Current conversation search text, shared between the search bar and the list/empty view. */
export const inboxPageConversationSearchTextStore = createExternalStore('');

/** Whether the inbox should show its empty-state container. */
export const inboxPageShowEmptyContainerStore = createExternalStore(false);

/** Whether the conversation list query returned an auth error (403/401). */
export const inboxPageAuthErrorStore = createExternalStore(false);
